import Layers from "slotworks/graphics/layers/layers";
import Components from "slotworks/components/components";
import rainbowStacksComponents from "components/components";
import { JackpotMeterComponentMode } from "components/jackpot/jackpot-meter-component";
import deviceInfo from "slotworks/utils/device-info";

export function ShowFreespinsElements() {
    Layers.Background.setScene("freespins").execute();
    Layers.MatrixBackground.setScene("freespins").execute();
    Layers.MatrixForeground.setScene("freespins").execute();
    if (Layers.Header.hasScene("freespins")) {
        Layers.Header.setScene("freespins").execute();
    }
    Components.banner.setMode("freespins");
    Layers.Custom.get("Grass").setScene("freespins").execute();
    Layers.Custom.get("River").setScene("freespins").execute();
}

export function HideFreespinsElements() {
    Layers.Background.defaultScene().execute();
    Layers.MatrixBackground.defaultScene().execute();
    Layers.MatrixForeground.defaultScene().execute();
    Layers.Header.defaultScene().execute();
    Components.banner.setMode("default");
    Layers.Custom.get("Grass").defaultScene().execute();
    Layers.Custom.get("River").defaultScene().execute();
}


// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./src/commands/freespins.ts